import { Sidebar, MobileNav } from "@/components/Sidebar";
import { ChatBot } from "@/components/ChatBot";
import { Outlet } from "react-router-dom";

export function AppShell() {
  return (
    <div className="min-h-screen flex bg-background">
      <Sidebar />
      <main className="flex-1 min-w-0">
        <MobileNav />
        <Outlet />
      </main>
      <ChatBot />
    </div>
  );
}
